import { useState } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Backdrop from '@mui/material/Backdrop';
import { useSelector, useDispatch } from "react-redux";
import { Button, Grid, Typography, CircularProgress } from "@mui/material"
import { ArrowForward } from '@mui/icons-material';
import React from "react";
import { deleteUser } from '../../services/AuthService';

const styles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60vw',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    header: {
      fontWeight: "bold",
      marginBottom: "1em"
    }
  };


export default function DeleteUser ({deletionState, setDeletionState, handleClose, handleAfterDelete}) { 
    const [view, setView] = React.useState('Dashboard');
    const [drawerState, setDrawerState] = React.useState('closed');

    const loggedInUser = useSelector((state) => state.user)
    const dispatch = useDispatch();
    const [isDeleted, setIsDeleted] = useState(false)
    const [isDeleteModalOpen] = useState(false) 

  const handleDeletion = async (userId) => {
    setIsDeleted(true);
    const response = await deleteUser(userId, loggedInUser);
    if (response) {
      if (response?.message === "success") {
        handleAfterDelete(userId);
        setDeletionState({ ...deletionState, isDeleteModalOpen: false })
      }
      setIsDeleted(false);
    }
  }

  return (
    <div>
        <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={deletionState?.isDeleteModalOpen}
        onClose={handleClose}
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Box sx={styles}>
            <Typography id="transition-modal-title" variant="h6" component="h2" style={styles.header}>
                Are you sure you want to delete the user?
            </Typography>
            <Grid
              container
              direction="row"
              sx={{
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Button variant="outlined" onClick={handleClose}>Cancel</Button>
              <Button 
                variant="contained"
                endIcon={isDeleted ? <CircularProgress color='inherit' size={20} /> : <ArrowForward />}
                onClick={() => {
                    handleDeletion(deletionState?.userId)
                }}
              >Delete</Button>
            </Grid>
          </Box>
          </Modal>
        </div>
  );
}